import React, { useState, useRef, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Component, TimeModal, TimeInput } from './TimePicker.style'
import { ThemeProvider } from 'styled-components'
import { theme } from './../../theme'
import { Carousel } from 'react-responsive-carousel'
import 'react-responsive-carousel/lib/styles/carousel.min.css'

const TimePicker = ({
  style,
  placeholder,
  className,
  isOpen,
  ...attributes
}) => {
  const ref = useRef(null)
  const modalRef = useRef(null)
  const [time, setTime] = useState({ format12: null })
  const [isModalOpen, setIsModalOpen] = useState(isOpen)
  useEffect(() => {
    setSvgs()
  }, [isOpen])
  const setSvgs = () => {
    const prev = modalRef?.current?.querySelectorAll('.control-prev') || []
    const next = modalRef?.current?.querySelectorAll('.control-next') || []
    console.log(prev, next)
    prev.forEach((item) => {
      item.innerHTML = `<i class="fa fa-chevron-down text-white" style="font-size: 12px" aria-hidden="true"></i>`
    })
    next.forEach((item) => {
      item.innerHTML = `<i class="fa fa-chevron-up text-white" style="font-size: 12px" aria-hidden="true"></i>`
    })
  }

  return (
    <ThemeProvider theme={theme}>
      <Component {...attributes}>
        <div className='input-container'>
          <TimeInput
            readOnly
            type='text'
            placeholder={placeholder}
            className={className}
            value={time.format12}
            ref={ref}
            style={style}
          />
          <span
            className='close-icon'
            onClick={() => setIsModalOpen(!isModalOpen)}
          >
            <svg width='30px' height='30px' viewBox='0 -3 161 161'>
              <g clipPath='url(#clip0)'>
                <path
                  d='M158.715 93.6772C157.802 100.245 154.818 106.136 151.805 111.92C146.72 121.822 139.589 130.529 130.887 137.462C120.603 145.626 108.844 150.515 95.9904 152.771C88.0228 154.17 79.9963 155.188 71.859 154.774C52.2411 153.776 35.307 146.909 21.5437 132.492C15.7041 126.273 10.7406 119.285 6.79072 111.721C4.50991 107.47 3.65356 103.024 2.8853 98.4666C1.46538 90.0357 0.591533 81.6125 1.52498 72.9954C2.67737 62.3531 5.61243 52.3786 10.9177 43.1078C17.3494 31.654 26.1617 21.7158 36.7593 13.9646C47.3128 6.30798 59.2571 2.38546 72.1621 0.825729C85.8424 -0.937555 99.7449 0.512547 112.769 5.06085C125.547 9.5513 136.951 16.4031 144.663 27.8945C152.375 39.3859 157.726 51.7955 159.542 65.8408C161.05 77.4943 159.507 87.9798 158.715 93.6772ZM151.262 76.3042C151.197 68.1236 150.427 60.0325 147.463 52.4251C145.02 46.1571 142.117 36.608 137.175 31.6597C130.308 22.099 120.75 16.2616 109.925 12.4034C97.5833 7.91381 84.3234 6.55027 71.3271 8.43433C58.0477 10.352 46.1501 15.2312 36.1452 24.3003C33.1929 26.9822 30.3803 29.8139 27.7183 32.7848C16.4134 45.378 10.3178 60.4191 10.3243 85.1613C10.3282 100.587 17.9305 113.773 28.8189 125.043C40.3765 137.006 54.3094 143.003 70.6049 144.343C78.5187 144.991 86.3198 144.129 94.1022 142.926C117.373 139.33 133.983 126.736 144.693 105.822C151.148 93.2167 150.872 80.9374 151.262 76.3042Z'
                  fill='black'
                />
                <path
                  d='M87.7202 74.8117C89.3144 74.8117 90.5102 74.8117 91.706 74.8117C101.785 74.8253 111.863 74.8221 121.941 74.8766C123.26 74.8869 124.572 75.0575 125.85 75.3844C126.511 75.5219 127.105 75.885 127.529 76.4117C127.953 76.9383 128.182 77.5965 128.176 78.273C128.242 78.9481 128.077 79.6258 127.708 80.1952C127.339 80.764 126.787 81.1907 126.144 81.4041C124.474 81.9586 122.728 82.2511 120.968 82.2705C111.113 82.1823 101.259 81.9592 91.4048 81.7874C89.3008 81.7504 87.1942 81.7951 85.0935 81.6881C83.9942 81.6505 82.9066 81.454 81.8637 81.1045C80.2158 80.5143 79.5479 79.2516 79.6716 77.448C79.9308 73.6956 80.1115 69.9367 80.2495 66.1778C80.6977 53.9944 81.0987 41.8091 81.5593 29.6257C81.6635 28.4129 81.8559 27.2091 82.1351 26.0243C82.4389 24.3977 83.3886 23.4548 85.0916 23.458C86.8535 23.4613 87.6619 24.6112 87.9664 26.145C88.2145 27.337 88.346 28.5505 88.3589 29.7683C88.3473 42.8479 88.3065 55.9277 88.2365 69.008C88.2268 70.7623 87.9327 72.5153 87.7202 74.8117Z'
                  fill='black'
                />
              </g>
              <defs>
                <clipPath id='clip0'>
                  <rect
                    width='160'
                    height='155'
                    fill='white'
                    transform='translate(0.777344)'
                  />
                </clipPath>
              </defs>
            </svg>
          </span>
        </div>
        <TimeModal ref={modalRef} isOpen={isModalOpen}>
          <div className='column'>
            <div className='am-pm-container scroll-container'>
              <Carousel
                axis='vertical'
                showIndicators={false}
                showArrows
                useKeyboardArrows
              >
                <div className='box'>AM</div>
                <div className='box'>PM</div>
              </Carousel>
            </div>
            <div className='hours-container scroll-container'>
              <Carousel
                axis='vertical'
                showIndicators={false}
                showArrows
                useKeyboardArrows
              >
                <div className='box' id={12}>
                  12
                </div>
                <div className='box' id={1}>
                  01
                </div>
                <div className='box' id={2}>
                  02
                </div>
                <div className='box' id={3}>
                  03
                </div>
                <div className='box' id={4}>
                  04
                </div>
                <div className='box' id={5}>
                  05
                </div>
                <div className='box' id={6}>
                  06
                </div>
                <div className='box' id={7}>
                  07
                </div>
                <div className='box' id={8}>
                  08
                </div>
                <div className='box' id={9}>
                  09
                </div>
                <div className='box' id={10}>
                  10
                </div>
                <div className='box' id={11}>
                  11
                </div>
                <div className='box' id={12}>
                  12
                </div>
              </Carousel>
            </div>
            <div className='minutes-container scroll-container'>
              <Carousel
                axis='vertical'
                showIndicators={false}
                showArrows
                useKeyboardArrows
              >
                {[...Array(60).keys()].map((item) => {
                  return (
                    <div className='box' key={item}>
                      {item.toString().length <= 1 ? `0${item}` : item}
                    </div>
                  )
                })}
              </Carousel>
            </div>
          </div>
        </TimeModal>
      </Component>
    </ThemeProvider>
  )
}
TimePicker.defaultProps = {
  isOpen: false
}

TimePicker.propTypes = {
  time: PropTypes.string,
  theme: PropTypes.string,
  color1: PropTypes.string,
  headerColor: PropTypes.string,
  placeholder: PropTypes.string.isRequired,
  className: PropTypes.string,
  style: PropTypes.object,
  isOpen: PropTypes.bool
}

export default TimePicker
export { TimePicker as CDBTimePicker }
